class DTO {
    dtoFromServer = (json) => {
        throw "Please implement dtoFromServer() function"
    }

    dtoToServer = () => {
        throw "Please implement dtoToServer() function"
    }
}

export default DTO;